import React, { Component } from "react";
import {
  Row,
  Wrapper,
  Button,
  DropzoneButton
} from "app/NativeComponents/common";
import { InputBox, CircleButton } from "app/NativeComponents/snippets";

class Inputs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uploading: false
    };

    this._new_password_input = React.createRef();
    this._new_password_confirm_input = React.createRef();
    this._old_password_input = React.createRef();
  }

  render() {
    const { editUser, loading } = this.props;
    return (
      <>
        <InputBox
          input_ref={this._new_password_input}
          name="new_password"
          disabled={loading}
          returnKeyType="next"
          placeholder="New Password"
          onChange={value =>
            this.props.updateUserFieldChange({ prop: "new_password", value })
          }
          onSubmitEditing={() => {
            this._new_password_confirm_input.current.focus();
          }}
          blurOnSubmit={false}
          value={editUser.new_password}
          secureTextEntry
          type="password"
        />
        <InputBox
          input_ref={this._new_password_confirm_input}
          name="new_password_confirm"
          disabled={loading}
          returnKeyType="next"
          placeholder="Confirm New Password"
          onChange={value =>
            this.props.updateUserFieldChange({
              prop: "new_password_confirm",
              value
            })
          }
          onSubmitEditing={() => {
            this._old_password_input.current.focus();
          }}
          blurOnSubmit={false}
          value={editUser.new_password_confirm}
          secureTextEntry
          type="password"
        />
        <InputBox
          input_ref={this._old_password_input}
          name="old_password"
          disabled={loading}
          returnKeyType="next"
          placeholder="Old Password"
          onChange={value =>
            this.props.updateUserFieldChange({ prop: "old_password", value })
          }
          onSubmitEditing={() => {
            this.props.saveUserInfo();
          }}
          blurOnSubmit={false}
          value={editUser.old_password}
          secureTextEntry
          type="password"
        />
      </>
    );
  }
}

export default Inputs;
